import {Component} from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
declare const InstallTrigger: any;
declare const device: any;
declare let gtag_report_conversion: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = '¿Cuánto cuesta desarrollar mi <strong>app</strong>?';
  subtitle = 'Calcular el costo de tu app nunca fue tan fácil! Solo contesta estas preguntas.';
  modal = false;
  section = 0;
  url = 'https://vicinosoftware.com';
  url2 = 'https://calcularmiapp.com';
  text_twitter = 'Calcula de forma fácil el costo para crear TU %23App con @VicinoSoftware. Obtén ahora tu %23presupuesto estimado en';
  price = 0;
  sections = [
    {
      id: 1,
      title: '¿Qué <strong>nivel</strong> de calidad estás buscando?',
      options: [
        {
          id: 1,
          hours: 24,
          img: './assets/img/2.png',
          text: 'Calidad óptima'
        },
        {
          id: 2,
          hours: 16,
          img: './assets/img/3.png',
          text: 'Buena relación calidad/precio'
        },
        {
          id: 3,
          hours: 8,
          img: './assets/img/4.png',
          text: 'No me importa tanto la calidad'
        }]
    },
    {
      id: 2,
      title: '¿Qué <strong>tipo</strong> de app necesitas?',
      options: [
        {
          id: 1,
          hours: 60,
          img: './assets/img/5.png',
          text: 'Aplicación Android'
        },
        {
          id: 2,
          hours: 60,
          img: './assets/img/6.png',
          text: 'Aplicación iOS'
        },
        {
          id: 3,
          hours: 60,
          img: './assets/img/7.png',
          text: 'Aplicación Windows Phone'
        },
        {
          id: 4,
          hours: 100,
          img: './assets/img/8.png',
          text: 'Aplicación Android + iOS'
        }]
    },
    {
      id: 3,
      title: '¿Qué <strong>diseño</strong> quieres que tenga tu App?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/9.png',
          text: 'Interfaz sencilla'
        },
        {
          id: 2,
          hours: 120,
          img: './assets/img/10.png',
          text: 'Interfaz personalizada'
        },
        {
          id: 3,
          hours: 80,
          img: './assets/img/11.png',
          text: 'Interfaz replicada de la web'
        },
        {
          id: 4,
          hours: 0,
          img: './assets/img/12.png',
          text: 'No necesito diseño'
        }]
    },
    {
      id: 4,
      title: '¿Cómo quieres sacar <strong>beneficio</strong> a tu App?',
      options: [
        {
          id: 1,
          hours: 5,
          img: './assets/img/13.png',
          text: 'Aplicación gratuita con publicidad'
        },
        {
          id: 2,
          hours: 5,
          img: './assets/img/14.png',
          text: 'Aplicación de pago'
        },
        {
          id: 3,
          hours: 40,
          img: './assets/img/15.png',
          text: 'Compras dentro de la app'
        },
        {
          id: 4,
          hours: 10,
          img: './assets/img/16.png',
          text: 'Otros / No lo sé todavía'
        }]
    },
    {
      id: 5,
      title: '¿Tu App necesita un sistema de <strong>login</strong>?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/17.png',
          text: 'Sí, con redes sociales y email'
        },
        {
          id: 2,
          hours: 25,
          img: './assets/img/18.png',
          text: 'Sí, con email'
        },
        {
          id: 3,
          hours: 0,
          img: './assets/img/19.png',
          text: 'No'
        },
        {
          id: 4,
          hours: 20,
          img: './assets/img/20.png',
          text: 'No lo sé todavía'
        }]
    },
    {
      id: 6,
      title: '¿Tu App tiene que estar <strong>integrada</strong> con un sitio web?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/21.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/22.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/23.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 7,
      title: '¿Los usuarios tienen sus propios <strong>perfiles</strong>?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/24.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/25.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/26.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 8,
      title: '¿Tu app necesita un <strong>panel</strong> de administración?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/27.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/28.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/29.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 9,
      title: '¿Qué <strong>idiomas</strong> usará tu aplicación?',
      options: [
        {
          id: 1,
          hours: 0,
          img: './assets/img/30.png',
          text: 'Un único idioma'
        },
        {
          id: 2,
          hours: 20,
          img: './assets/img/31.png',
          text: 'Bilingüe'
        },
        {
          id: 3,
          hours: 40,
          img: './assets/img/32.png',
          text: 'Multilingüe'
        }]
    },
    {
      id: 10,
      title: '¿En qué <strong>estado</strong> se encuentra tu proyecto?',
      options: [
        {
          id: 1,
          hours: 0,
          img: './assets/img/33.png',
          text: 'Sólo es una idea'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/34.png',
          text: 'Boceto ya preparado'
        },
        {
          id: 3,
          hours: 0,
          img: './assets/img/35.png',
          text: 'App en desarrollo'
        },
        {
          id: 4,
          hours: 0,
          img: './assets/img/36.png',
          text: 'App ya desarrollada'
        }]
    }];
  selected = {};
  showAnswers = false;
  selectedArray = [];
  finish = false;
  ipRequest = {};
  time_init = 0;
  currentRoute: boolean = false;

  config: Observable<{}>;
  configRef: AngularFirestoreCollection<any>;
  itemRef: AngularFirestoreCollection<any>;

  constructor(db: AngularFirestore, private httpClient: HttpClient) {
    this.itemRef = db.collection('statistics');
    this.configRef = db.collection('config');
    this.config = this.configRef.doc("config").valueChanges();
  }

  ngOnInit() {
    this.time_init = new Date().getTime();
    document.addEventListener("deviceready", function() {
      alert(device.platform);
    }, false);
    if (window.location.href.toString().split(window.location.host)[1] === '/statistics') {
      this.currentRoute = true;
    }
  }

  toggleModal(): void {
    this.modal = !this.modal;
  }

  updateSection(x, select): void {
    if (this.finish) {
      this.section = 11;
    } else {
      this.section = x;
    }
    if (select) {
      this.selected[select.section.id] = {
        id: select.section.id,
        title: select.section.title,
        option: select.option
      };
    }
    this.updatePrice();
  }

  updatePrice(): void {
    this.price = 0;
    this.selectedArray = [];
    for (let i = 0; i <= this.section - 1; i++) {
      if (this.selected[i] && this.selected[i] !== this.selected[1])
      this.price += this.selected[i].option.hours * this.selected[1].option.hours;

      if(this.section === 11 && this.selected[i]) {
        this.selectedArray.push(this.selected[i])
      }
    }
    if(this.section === 11 && this.finish === false) {
      // this.saveData();
      gtag_report_conversion()
    }
  }

  toggleAnswers(): void {
    this.showAnswers = !this.showAnswers;
  }

  changeAnswer(a): void {
    this.section = a.id;
    this.finish = true
  }

  private saveData(): void {

    this.config.subscribe((x) => {
      this.httpClient.get(x['ipURL'] || 'https://ipapi.co/json').subscribe((res : any[]) => {
        this.ipRequest = res;

        let data = {ipRequest: this.ipRequest, selected: this.selected, time_init: this.time_init, time_finish: new Date().getTime(), price: this.price, browser: this.getBrowser()};
        this.itemRef.add(data)
          .then(function(docRef) {
            // console.log("Document written with ID: ", docRef.id);
          })
          .catch(function(error) {
            // console.error("Error adding document: ", error);
          });

      });
    });
  }

  isMobile() {
    return /Mobi/.test(navigator.userAgent);
  }

  getBrowserName() {
    // Opera 8.0+
    if ((window['opr'] && window['opr'].addons)
      || window['opera']
      || navigator.userAgent.indexOf(' OPR/') >= 0) {
      return 'Opera';
    }

    // Firefox 1.0+
    if (typeof InstallTrigger !== 'undefined') {
      return 'Firefox';
    }

    // Safari 3.0+ "[object HTMLElementConstructor]"
    if (/constructor/i.test(window['HTMLElement']) || (function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    })(!window['safari'])) {
      return 'Safari';
    }

    // Internet Explorer 6-11
    if (/* @cc_on!@*/false || document['documentMode']) {
      return 'Internet Explorer';
    }

    // Edge 20+
    if (!(document['documentMode']) && window['StyleMedia']) {
      return 'Microsoft Edge';
    }

    // Chrome
    if (window['chrome']) {
      return 'Chrome';
    }
  }

  getOSName() {
    var os;
    if (this.isMobile()) {
      if (/Windows/.test(navigator.userAgent)) {
        os = 'Windows';
        if (/Phone 8.0/.test(navigator.userAgent)) {
          os += ' Phone 8.0';
        } else if (/Phone 10.0/.test(navigator.userAgent)) {
          os += ' Phone 10.0';
        }
      } else if (/Android/.test(navigator.userAgent)) {
        let androidVersion = () => {
          if (/Android/.test(navigator.appVersion)) {
            var v = (navigator.appVersion).match(/Android (\d+).(\d+)/);
            return v;
          }
        };

        let ver = androidVersion();
        os = ver[0];
      } else if (/iPhone;/.test(navigator.userAgent)) {
        let iOSversion = () => {
          if (/iP(hone|od|ad)/.test(navigator.appVersion)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || '0', 10)];
          }
        };

        let ver = iOSversion();
        os = 'iOS ' + ver[0] + '.' + ver[1] + '.' + ver[2];
      } else if (/iPad;/.test(navigator.userAgent)) {
        let iOSversion = () => {
          if (/iP(hone|od|ad)/.test(navigator.appVersion)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || '0', 10)];
          }
        };

        var ver = iOSversion();
        os = 'iOS ' + ver[0] + '.' + ver[1] + '.' + ver[2];
      } else if (/BBd*/.test(navigator.userAgent)) {
        os = 'BlackBerry';
      }
    } else {
      if (/Windows/.test(navigator.userAgent)) {
        os = 'Windows';
        if (/5.1;/.test(navigator.userAgent)) {
          os += ' XP';
        } else if (/6.0;/.test(navigator.userAgent)) {
          os += ' Vista';
        } else if (/6.1;/.test(navigator.userAgent)) {
          os += ' 7';
        } else if (/6.2/.test(navigator.userAgent)) {
          os += ' 8';
        } else if (/10.0;/.test(navigator.userAgent)) {
          os += ' 10';
        }

        if (/64/.test(navigator.userAgent)) {
          os += ' 64-bit';
        } else {
          os += ' 32-bit';
        }
      } else if (/Macintosh/.test(navigator.userAgent)) {
        os = 'Macintosh';
        if (/OS X/.test(navigator.userAgent)) {
          os += ' OS X';
        }
      }
    }

    return os;
  }

  getBrowser() {
    return {
      os: this.getOSName(),
      browser: this.getBrowserName(),
      language: navigator.language,
      languages: navigator.languages,
      user_agent: navigator.userAgent,
      device: this.isMobile() ? 'Mobile' : 'Desktop',
      referrer: document.referrer || 'N/A',
      online: navigator.onLine,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screen_resolution: screen.width + ' x ' + screen.height,
      cookie_enabled: navigator.cookieEnabled,
    };
  }
}
